/*
 * @Author: monai
 * @Date: 2021-04-25 17:59:41
 * @LastEditors: muqing
 * @LastEditTime: 2024-08-29 17:04:37
 */
import {getQueryString} from '@activity-business/h5-package-frameworkTool';
import {fnColorLog} from '@activity-business/h5-package-frameworkTool';

interface currentCacheType {
    //  文案缓存数据
    list: string[],
    //  超时时间戳
    expireTimestamp: number
}
//  缓存文案 key 的关键词
const keyName = 'languageCache';
//  缓存开关，不挂参数默认使用。关闭时会清空所有缓存数据，预留 URL 参数接口。
const cacheSwitch = getQueryString('languageCacheSwitch') === 'noCache' ? false: true;
//  过期时间为 3天
const expireTime = 1000 * 60 *60 *24 * 3;

class LanguageTextCache{
    
    public cacheSwitch!: boolean;
    public expireTime!: number;
    public currentTimestamp: number;
    public keyName!: string;
    public currentKeyName: string;
    public currentCache: currentCacheType | null;
    
    constructor(
        public activityId: number = activityId, 
        public countryCode: string = countryCode,
        public reactiveText: string[]
    ){
        Object.assign(this, { cacheSwitch, expireTime, keyName });
        //  当前H5使用的文案缓存 KEY
        this.currentKeyName = `${keyName}_${activityId}_${countryCode}`;
        //  当前H5使用的文案缓存
        this.currentCache = null;
        this.currentTimestamp = Date.now();
        //  文案缓存初始化
        this.initialization(reactiveText);
    }//  初始化
    initialization(reactiveText: string[]): void{
        
        //  不适用缓存
        if(!this.cacheSwitch){
            localStorage.clear();
            return;
        }
        let { clearExpireCache, filterIrregular, currentKeyName } = this;
        //  先清空过期文案，解构后this丢失
        clearExpireCache.call(this);
        //  获取当前页面文案数据失败
        if( !(this.currentCache = filterIrregular(currentKeyName)) )return;
        //  使用文案缓存赋值双向绑定数据
        reactiveText.push(...this.currentCache.list);
        fnColorLog(['developTool_share', '本地缓存文案'], 'info', this.currentCache.list);
    }
    //  清空过期文案
    clearExpireCache(){
        
        let { keyName, filterIrregular, currentTimestamp } = this, cacheObj: null | currentCacheType;
        
        for(let key in localStorage){
            //  key 不包含语言缓存直接跳过
            if( !key.includes( keyName ) )continue;
            //  当前缓存数据不符合存储规范跳过
            if( !(cacheObj = filterIrregular(key)) )continue;
            //  文案过期清空当前 key
            if( cacheObj.expireTimestamp - currentTimestamp <= 0 ){
                localStorage.removeItem(key);
                fnColorLog(['developTool_share', '已过期的文案缓存 key'], 'info', key);
            };
        }
    }
    //  过滤不符合规则的缓存文案
    filterIrregular(key: string): null | currentCacheType{
        let JSONData: null | string = localStorage.getItem(key), data: currentCacheType;
        //  未获取到当前 key 数据，删除污染key
        if(!JSONData){
            localStorage.removeItem(key);
            return null;
        }
        try{
            data = JSON.parse(JSONData);
        }
        //  当前数据解析失败，删除污染key
        catch(err){ 
            localStorage.removeItem(key);
            return null;
        };
        let { list, expireTimestamp } = data;
        //  当前数据解析后不存在过期时间，删除污染key
        //  当前数据解析后不存在文案数组，删除污染key
        //  当前数据解析后 list 不是 Array，删除污染key
        if(!expireTimestamp || !list || !toString.call(list).includes('Array')){
            localStorage.removeItem(key);
            return null;
        }
        //  符合规则的文案数据
        return { list, expireTimestamp };
    }
    //  更新文案数据
    updateDate( list: string[] ): void{
        let { currentTimestamp, expireTime, currentKeyName } = this;
        //  避免存储满了浏览器报错
        try{
            //  刷新本地语言缓存为最新数据
            localStorage.setItem( currentKeyName, JSON.stringify({list, expireTimestamp: currentTimestamp + expireTime}));
        }
        //  全满直接清空，释放存储
        catch(err){
            localStorage.clear();
        }
    }
    //  缓存文案是否与对应数据匹配
    matchCache( list: string[] ): boolean{
        let { cacheSwitch, currentCache } = this;
        //  使用文案缓存开关开启
        //  当前H5页成功解析缓存文案数据
        //  缓存文案与当前接口文案数量相等
        //  缓存文案与接口文案完全相等
        let isMatch: boolean = cacheSwitch && (currentCache !== null) && (list.length == currentCache.list.length) && !list.find(( item, index )=>(item !== (currentCache as currentCacheType).list[index]));
        
        return isMatch;
    }
}

export default LanguageTextCache;